import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import type { CouponPaymentSourceSB } from '@mwl/core-lib';
import { selectUserCurrency, useLocalizedNumberFormatters, useToggle } from '@mwl/core-lib';
import type { DropdownClasses } from '@/components/Dropdown/Dropdown';
import { Dropdown } from '@/components/Dropdown/Dropdown';
import { useAccountSelectItems, useTypedSelector } from '@/hooks';
import { CouponAccountSelectItem } from '../CouponAccountSelectItem/CouponAccountSelectItem';
import type { CouponAccountSelectProps } from './CouponAccountSelect.types';
import styles from './CouponAccountSelect.module.scss';
const dropdownClasses: DropdownClasses = {
  container: styles.dropdownContainer,
  content: styles.dropdownContent
};
const CouponAccountSelect: FC<CouponAccountSelectProps> = ({
  onSelectItem
}) => {
  const {
    t
  } = useTranslation('sport');
  const [isOpened, toggleOpened] = useToggle(false);
  const currency = useTypedSelector(selectUserCurrency);
  const {
    formatPriceByCurrencyCodeWithLocale
  } = useLocalizedNumberFormatters();
  const handleSelectOpen = () => {
    toggleOpened();
  };
  const {
    activeItem,
    optionItems,
    setActiveItem
  } = useAccountSelectItems({
    isRunAnimation: false
  });
  const handleSelectItem = ({
    id,
    type
  }: CouponPaymentSourceSB) => {
    setActiveItem({
      id,
      type
    });
    toggleOpened(false);
    onSelectItem?.();
  };
  if (!optionItems?.length || !activeItem) {
    return null;
  }
  if (optionItems.length === 1) {
    return <CouponAccountSelectItem {...activeItem} active text={t(activeItem.text)} classes={{
      amount: cn({
        [styles.zeroAmount]: +activeItem.amount === 0
      })
    }} amount={formatPriceByCurrencyCodeWithLocale(+activeItem.amount, currency)} className={styles.title} />;
  }
  return <div className={styles.root} data-sentry-component="CouponAccountSelect" data-sentry-source-file="CouponAccountSelect.tsx">
      <Dropdown customHeader={!!activeItem && <CouponAccountSelectItem {...activeItem} active={false} text={t(activeItem.text)} classes={{
      amount: cn({
        [styles.zeroAmount]: +activeItem.amount === 0
      })
    }} amount={formatPriceByCurrencyCodeWithLocale(+activeItem.amount, currency)} className={cn(styles.title, {
      [styles.opened]: isOpened
    })} withArrow />} active={isOpened} onToggle={handleSelectOpen} classes={dropdownClasses} data-sentry-element="Dropdown" data-sentry-source-file="CouponAccountSelect.tsx">
        {optionItems.map(selectItem => {
        return <CouponAccountSelectItem {...selectItem} text={t(selectItem.text)} classes={{
          amount: cn({
            [styles.disabled]: +selectItem.amount === 0 || selectItem.disabled
          })
        }} amount={formatPriceByCurrencyCodeWithLocale(selectItem.amount, currency)} onClick={() => handleSelectItem({
          id: selectItem.id,
          type: selectItem.type
        })} key={selectItem.id + selectItem.type} className={cn(styles.selectItem, {
          [styles.freebetBorder]: selectItem.type === 'FREEBET'
        })} />;
      })}
      </Dropdown>
    </div>;
};
export { CouponAccountSelect };